import { ReactComponent as Triangle } from 'assets/warningTriangle.svg'
import React from 'react'

interface AlertProps extends warehouse.WarehouseAlert { }

const Alert: React.FC<AlertProps> = ({ title, desc, warning, action, buttonText }) => {
  return (
    <div className='warehouse__popup'>
      <div className='popup__title'>
        {warning && <Triangle />}
        <div className='--secFont'>{title}</div>
        <div>{desc}</div>
      </div>

      {action && <div
        className='popup__button'
        onClick={e => {
          action()
          e.stopPropagation()
        }}>
        {buttonText}
      </div>}
    </div>
  )
}

export default Alert